// import React from "react";
// import { motion } from "framer-motion";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { logoutUser } from "../store/userSlice";

// const ProfilePage = () => {
//   const user = useSelector((state) => state.user.user);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     dispatch(logoutUser());
//     localStorage.clear();
//     navigate("/login");
//   };

//   return (
//     <div className="p-2 md:p-4">

//       {/* USER CARD */}
//       <div className="bg-white rounded-2xl shadow p-4 md:p-6 flex items-center gap-4">

//         <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-black text-white flex items-center justify-center text-lg font-bold">
//           {user?.name?.charAt(0) || "U"}
//         </div>

//         <div>
//           <h2 className="text-lg md:text-xl font-semibold">
//             {user?.name}
//           </h2>
//           <p className="text-gray-500 text-sm">
//             {user?.email}
//           </p>
//         </div>

//       </div>

//       {/* ACTION CARDS */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">

//         <div
//           onClick={() => navigate("/account/orders")}
//           className="bg-white p-4 rounded-xl shadow hover:shadow-md cursor-pointer"
//         >
//           <h3 className="font-semibold">My Orders</h3>
//           <p className="text-sm text-gray-500">
//             Track your orders
//           </p>
//         </div>

//         <div
//           onClick={() => navigate("/account/address")}
//           className="bg-white p-4 rounded-xl shadow hover:shadow-md cursor-pointer"
//         >
//           <h3 className="font-semibold">Addresses</h3>
//           <p className="text-sm text-gray-500">
//             Manage address
//           </p>
//         </div>

//         <div className="bg-white p-4 rounded-xl shadow">
//           <h3 className="font-semibold">Account Settings</h3>
//           <p className="text-sm text-gray-500">
//             Update profile
//           </p>
//         </div>

//         <div
//           onClick={handleLogout}
//           className="bg-red-50 p-4 rounded-xl shadow cursor-pointer"
//         >
//           <h3 className="font-semibold text-red-600">
//             Logout
//           </h3>
//         </div>

//       </div>

//     </div>
//   );
// };

// export default ProfilePage;
import React, { useState } from "react";
import { motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../store/userSlice";
import { FaUserEdit, FaBox, FaMapMarkerAlt, FaSignOutAlt, FaLaptop } from "react-icons/fa";

const ProfilePage = () => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user?.name || "");

  const handleLogout = () => {
    dispatch(logoutUser());
    localStorage.clear();
    navigate("/login");
  };

  // 🔥 UPDATE PROFILE (Frontend only for now)
  const handleUpdate = () => {
    // 👉 yaha API call laga sakta hai
    alert("Profile updated (connect API)");
    setEditing(false);
  };

  return (
    <div className="text-white">

      {/* 🔥 PROFILE CARD */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-3xl p-5 md:p-6 flex flex-col sm:flex-row items-center gap-4 shadow-lg"
      >
        {/* Avatar */}
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gradient-to-r from-green-400 to-green-600 flex items-center justify-center text-xl font-bold shadow-lg">
          {user?.name?.charAt(0) || "U"}
        </div>

        {/* Info */}
        <div className="flex-1 text-center sm:text-left">
          {editing ? (
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="bg-white/10 border border-white/20 p-2 rounded-lg w-full outline-none"
            />
          ) : (
            <h2 className="text-xl font-semibold">{user?.name}</h2>
          )}

          <p className="text-gray-300 text-sm">{user?.email}</p>

          {/* Badge */}
          <span className="text-xs bg-green-500/20 px-3 py-1 rounded-full mt-2 inline-block">
            Verified User
          </span>
        </div>

        {/* Edit Button */}
        <div>
          {editing ? (
            <button
              onClick={handleUpdate}
              className="bg-green-500 px-4 py-2 rounded-lg text-sm"
            >
              Save
            </button>
          ) : (
            <button
              onClick={() => setEditing(true)}
              className="flex items-center gap-2 text-sm bg-white/10 px-4 py-2 rounded-lg hover:bg-white/20"
            >
              <FaUserEdit /> Edit
            </button>
          )}
        </div>
      </motion.div>

      {/* 🔥 QUICK STATS (Refurbished touch) */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-5">
        <div className="bg-white/10 p-4 rounded-xl text-center">
          <FaLaptop className="mx-auto mb-2 text-green-400" />
          <p className="text-sm text-gray-300">Devices</p>
          <p className="font-bold">3</p>
        </div>

        <div className="bg-white/10 p-4 rounded-xl text-center">
          <p className="text-sm text-gray-300">Orders</p>
          <p className="font-bold">5</p>
        </div>

        <div className="bg-white/10 p-4 rounded-xl text-center">
          <p className="text-sm text-gray-300">Warranty</p>
          <p className="font-bold text-green-400">Active</p>
        </div>
      </div>

      {/* 🔥 ACTION CARDS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">

        <motion.div
          whileHover={{ scale: 1.03 }}
          onClick={() => navigate("/account/orders")}
          className="bg-white/10 p-5 rounded-xl cursor-pointer"
        >
          <FaBox className="text-green-400 mb-2" />
          <h3 className="font-semibold">My Orders</h3>
          <p className="text-sm text-gray-400">
            Track your refurbished laptops
          </p>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.03 }}
          onClick={() => navigate("/account/address")}
          className="bg-white/10 p-5 rounded-xl cursor-pointer"
        >
          <FaMapMarkerAlt className="text-green-400 mb-2" />
          <h3 className="font-semibold">Addresses</h3>
          <p className="text-sm text-gray-400">
            Manage delivery locations
          </p>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.03 }}
          className="bg-white/10 p-5 rounded-xl"
        >
          <h3 className="font-semibold">Account Settings</h3>
          <p className="text-sm text-gray-400">
            Update preferences
          </p>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.03 }}
          onClick={handleLogout}
          className="bg-red-500/20 p-5 rounded-xl cursor-pointer"
        >
          <FaSignOutAlt className="text-red-400 mb-2" />
          <h3 className="font-semibold text-red-400">Logout</h3>
        </motion.div>

      </div>

    </div>
  );
};

export default ProfilePage;